import "@babel/polyfill";
/**
 * Creates an HTML Image element from a source URL
 */
export const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) => reject(error));
    image.setAttribute("crossOrigin", "anonymous");
    image.src = url;
  });

/**
 * Returns the cropped image as a base64 string scaled to target dimensions.
 * targetWidth and targetHeight should be calculated as Inches * 300 for 300 PPI.
 */

export const getCroppedImg = async (
  imageSrc,
  pixelCrop,
  targetWidth,
  targetHeight,
  mimeType = "image/jpeg"
) => {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  if (!ctx) return "";

  // Native Resolution Cap approach:
  // If the actual cropped area of the source image is smaller than the target width/height,
  // we cap the canvas dimensions to match the native cropped pixels exactly.
  // This prevents upscale bloating of small image crops.
  const needsUpscale =
    pixelCrop.width < targetWidth || pixelCrop.height < targetHeight;

  const finalWidth = needsUpscale ? pixelCrop.width : targetWidth;
  const finalHeight = needsUpscale ? pixelCrop.height : targetHeight;

  canvas.width = finalWidth;
  canvas.height = finalHeight;

  // Fill background white
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  // Calculate the scale ratio between the source selection and target canvas
  // Since aspect ratios are synced, scaling by height or width works the same
  const scale = finalHeight / pixelCrop.height;

  // Draw the image scaled and offset
  // We draw the full image but offset/scale so only the selection fills the canvas
  ctx.drawImage(
    image,
    -pixelCrop.x * scale,
    -pixelCrop.y * scale,
    image.width * scale,
    image.height * scale
  );

  return canvas.toDataURL(mimeType, 0.95);
};
